// extracted by mini-css-extract-plugin
export var image = "_j7-0";